import { EVENTS as APP_EVENTS } from '@/shared/constants/commons'

const EVENTS = {
  ...APP_EVENTS,
  LOGIN_FORM_SUBMITTED: 'loginFormSubmitted',
  LOGIN_STARTED: 'loginStarted',
  LOGIN_FINISHED: 'loginFinished',
  SIGNUP_FORM_SUBMITTED: 'signupFormSubmitted',
  SIGNUP_STARTED: 'signupStarted',
  SIGNUP_FINISHED: 'signupFinished',
}

const CONFIGS = {
  DEFUALT_LANG: 'fr',
}

export { EVENTS, CONFIGS }
